module.exports = __webpack_public_path__ + "img/kz.e84b9748.svg";